import { API_GET_ACCOUNTS_SUCCESS } from '@api/lendingAPI/LendingAPI.actions';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { GetAccountsResponse } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { DashboardActionPanel } from '../../OutstandingView/dashboardActions/DashboardActionPanel';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    syncReduxStore: (accountsResponse: GetAccountsResponse) => {
        dispatch({
            type: API_GET_ACCOUNTS_SUCCESS,
            response: accountsResponse
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const DrawdownPanel = ({
    accountId,
    syncReduxStore
}: { accountId: string } & PropsFromRedux) => {
    const stateKey = useStateKey();

    const { data: accountsResponse, isLoading } = useQuery(
        getAccountsQueryConfig(stateKey)
    );

    if (isLoading) return null;

    syncReduxStore(accountsResponse!);

    return (
        <DashboardActionPanel
            accountId={accountId}
            activeDashboardAction="top-up-drawdown-action"
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DrawdownPanel);
